module.exports = __webpack_public_path__ + "0ac43bbc113c15ee6215cb01059dcf91.svg";